export default function convertConsentSaveResponse(response) {
  // In the old days, `response.id` was an integer value (a true ID and
  // not a UUID). We leveraged that fact in the consent sync code to make
  // a simple greater-than comparison...but now, the `id` param returned
  // by the ConsentService is a UUID, which breaks that. So, to quickly
  // restore order we're going to replace the missing `id` with epoch
  // seconds.
  const id = new Date(response.create_time).valueOf()

  return {
    ...response.is_consent_granted_selections,
    ac_string: response.ac_string,
    document_version_id: response.document_version_id,
    event_type: response.display_style,
    gpc: response.gpc_enabled,
    id,
    tc_string: response.tc_string,
    template_version_id: response.document_version_id,
    visitor: {
      uuid: response.visitor.id,
    },
    visitor_id: response.visitor.id,
  }
}
